<template>
  <div class="single-deal" v-if="agent.id">
    <header class="page-header">
      <div v-show="this.bannerOpen" >
        <banner :href="virtualToursLpUrl" @close="closeBanner()" :galabel="`AID=${ agent.id } | LeadId=${ lead.id }`"></banner>
      </div>
      <lead-header />
    </header>
    <article>
      <div class="ut-container-sm">

        <!-- Lead Progress Section -->
        <section v-if='leadIsActive'>
          <div class="ut-flex ut-mb-6">
            <div class="ut-text-left ut-ml-0">
              <h2 class="ut-text-xl ut-font-bold">Progress update</h2>
            </div>
            <div class="ut-mr-0">
              <pill
                :danger="requiredUpdate"
                :happy="lamIsListed">
                {{ pillText }}
                <!-- <span v-if="lamIsActive && !lamIsListed">
                  {{ (this.lam.agentlastupdatedate || this.lam.modifieddate) | ago }}
                </span>
                <span v-if="lamIsOnHold">
                  On hold until {{this.lam.lamoffholddatetime | formatDate("D MMM YYYY") }}
                </span>
                <span v-if="lamIsListed">{{ listedPillTxt }}</span>
                <span v-if="lamIsLost || lamIsClosed">{{ closedPillTxt }}</span> -->
              </pill>
            </div>
          </div>

          <!-- Lead Progress Timeline -->
          <timeline-accordian>
            <timeline-accordian-item
              :name="sections.LeadInfo.name"
              :isOpen="openLeadInfo"
              :isDone="alreadyViewed"
              @click-header="headerClicked">
              <h3 slot="title">Review vendor and property details</h3>
              <template slot="body">
                <property-details />
              </template>
            </timeline-accordian-item>
            <timeline-accordian-item
              v-if='lamIsPreListed'
              :name="sections.Contacted.name"
              :isOpen="openContacted"
              :isDone="alreadyContacted"
              :isOpenable="!alreadyContacted || (!alreadyAppraised && isMissingContactedAppraisalDetails)"
              @click-header="headerClicked">
              <h3 slot="title">Contact vendor</h3>
              <template slot="body">
                <other-agent-lead-stage-change-notification
                  v-if="lamStageIsLessThanContacted && lam.premierid != null"
                  :agentId="lam.agentid"
                  :leadId="lead.id"
                  :lamStage="lam.stagetypeid"
                  :vendorName="lead.firstname" />
                <contact-vendor
                  v-if="lamStageIsLessThanContacted"
                />
                <contact-vendor-appraisal-detail
                  v-else-if="contactedDetails !== null"
                  :contactedDetails="contactedDetails"
                  @set-contacted-details="setContactedDetails"
                />
              </template>
            </timeline-accordian-item>
            <timeline-accordian-item
              v-if='lamIsPreListed'
              :name="sections.Appraised.name"
              :isOpen="openAppraised"
              :isDone="alreadyAppraised"
              :isOpenable="!alreadyAppraised"
              @click-header="headerClicked">
              <h3 slot="title">Appraise property</h3>
              <template slot="body">
                <other-agent-lead-stage-change-notification
                  v-if="lamStageIsContacted && lam.premierid != null"
                  :leadId="lead.id"
                  :agentId="lam.agentid"
                  :lamStage="lam.stagetypeid"
                  :vendorName="lead.firstname"
                />
                <property-appraisal />
              </template>
            </timeline-accordian-item>
            <timeline-accordian-item
              :name="sections.Listed.name"
              :isOpen="openListed"
              :isDone="alreadyListed"
              :isOpenable="!hasListingAgreement"
              @click-header="headerClicked">
              <h3 slot="title">List property
                <span v-if="!lamIsPreListed && !hasListingAgreement"
                  class="ut-text-xs ut-italic ut-pl-6">
                  (Please provide listing agreement)
                </span>
              </h3>
              <template slot="body">
                <div class="tabs"
                  v-if="!(alreadyListed && !hasListingAgreement)">
                  <button
                    class="tab"
                    :class="listedActiveTab ? 'tab-active': ''"
                    @click="listedActiveTab = true">
                    Upload documents
                  </button>
                  <button
                    class="tab"
                    :class="!listedActiveTab ? 'tab-active': ''"
                    @click="listedActiveTab = false">
                    Enter Manually
                  </button>
                </div>
                <property-listing-upload :selected="alreadyListed ? true : listedActiveTab" />
                <property-listing-manual :selected="alreadyListed ? false : !listedActiveTab" />
              </template>
            </timeline-accordian-item>
            <timeline-accordian-item
              v-if='!lamIsPreListed'
              :name="sections.UnderOffer.name"
              :isOpen="openUnderOffer"
              :isDone="alreadyUnderOffer"
              :isOpenable="!alreadyUnderOffer"
              @click-header="headerClicked">
              <h3 slot="title">Under offer</h3>
              <template slot="body">
                <under-offer />
              </template>
            </timeline-accordian-item>
            <timeline-accordian-item
              v-if="!lamIsPreListed"
              :name="sections.Sold.name"
              :isOpen="openSold"
              :isDone="alreadySold"
              :isOpenable="!hasContractOfSale"
              @click-header="headerClicked">
              <h3 slot="title">Sold property
                <span v-if="!hasContractOfSale"
                  class="ut-text-xs ut-italic ut-pl-6">
                  (Please provide contract of sale)
                </span>
              </h3>
              <template slot="body">
                <div
                  class="tabs"
                  v-if="!(alreadySold && !hasContractOfSale)">
                  <button
                    class="tab"
                    :class="soldActiveTab? 'tab-active': ''"
                    @click="soldActiveTab = true">
                    Upload documents
                  </button>
                  <button
                    class="tab"
                    :class="!soldActiveTab? 'tab-active': ''"
                    @click="soldActiveTab = false">
                    Enter Manually
                  </button>
                </div>
                <property-sold-upload :selected="alreadySold ? true : soldActiveTab"/>
                <property-sold-manual :selected="alreadySold ? false : !soldActiveTab" />
              </template>
            </timeline-accordian-item>
            <timeline-accordian-item
              v-if='!lamIsPreListed'
              :name="sections.Review.name"
              :isOpen="openReview"
              :isDone="alreadyReviewed"
              :isOpenable="!alreadyReviewed"
              @click-header="headerClicked">
              <h3 slot="title">Request a review</h3>
              <template slot="body">
                <review />
              </template>
            </timeline-accordian-item>
          </timeline-accordian>
        </section>

        <section v-if='lamIsLost'>
          <lead-unavailable-info
            :infotitle="'This lead is lost'"
            :infobody="`This lead was moved to lost by OpenAgent on ${
              this.formatDate(this.lam.leadlostdate)
            }. Please contact ${
              this.lead.assignedconsultantfirstname
            } for more information.`"
            :infostatus="'lost'" />
        </section>

        <section v-if='lamIsPassedBack'>
          <lead-unavailable-info
            :infotitle="'OpenAgent is following up'"
            :infobody="`You asked OpenAgent to follow up on ${
              this.formatDate(this.lam.leaddeclineddate)
            }. Please contact ${
              this.lead.assignedconsultantfirstname
            } if you'd like to reactivate this lead.`"
            :infostatus="'passedback'" />
        </section>

        <section v-if='lamIsClosedCloseLead'>
          <lead-unavailable-info
            :infotitle="'This lead is closed'"
            :infobody="`You closed this lead on ${
              this.formatDate(this.lam.leaddeclineddate)
            }. Please contact ${
              this.lead.assignedconsultantfirstname
            } if you'd like to reactivate this lead.`"
            :infostatus="'closed'" />
        </section>

        <section>
          <general-update :showMessage="showGeneralUpdateMsgInput" />
        </section>

        <section class="ut-mb-6">
          <div class="ut-text-left ut-ml-0">
            <h2 class="ut-text-xl ut-font-bold ut-mb-6">Referral Terms</h2>
            <p v-if='isPremier'>This referral is governed by the OpenAgent Premier Terms and Conditions. For this Premier Lead, the variable Success Fee applicable is {{(calculatedVLP+2).toFixed(2)}}% + GST, calculated against the total commission for the sale of the property. As an OpenAgent Premier customer, you are entitled to a 2% reduction on this Lead’s Success Fee. This means a fee equal to <span class="ut-text-green-400">{{calculatedVLP.toFixed(2)}}%</span> + GST will be calculated against the total commission and is payable upon the successful sale of this Premier Lead.</p>
            <p v-else>This referral is governed by our Agent Referral Terms. Our referral fees take into account different variables to determine a variable fee for each specific lead. For this lead, a fee equal to <span class="ut-text-green-400">{{calculatedVLP.toFixed(2)}}%</span> of the total sales commission (plus GST) is payable on settlement for a successful sale, unless you provide written evidence within the next two (2) days of a formal appraisal conducted by your agency within the last 60 days.</p>
          </div>
        </section>
      </div>
    </article>
  </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex';
import TimelineAccordian from '@/components/Accordions/TimelineAccordian.vue';
import TimelineAccordianItem from '@/components/Accordions/TimelineAccordianItem.vue';
import LeadHeader from '@/components/LeadHeader.vue';
import LeadUnavailableInfo from '@/components/LeadUnavailableInfo.vue';
import GeneralUpdate from '@/components/GeneralUpdate.vue';
import PropertyDetails from '@/components/PropertyDetails.vue';
import ContactVendor from '@/components/LeadAgentStageUpdates/ContactVendor.vue';
import ContactVendorAppraisalDetail from '@/components/LeadAgentStageUpdates/ContactVendorAppraisalDetail.vue';
import PropertyAppraisal from '@/components/LeadAgentStageUpdates/PropertyAppraisal.vue';
import PropertyListingManual from '@/components/LeadAgentStageUpdates/PropertyListingManual.vue';
import PropertyListingUpload from '@/components/LeadAgentStageUpdates/PropertyListingUpload.vue';
import UnderOffer from '@/components/LeadAgentStageUpdates/UnderOffer.vue';
import PropertySoldManual from '@/components/LeadAgentStageUpdates/PropertySoldManual.vue';
import PropertySoldUpload from '@/components/LeadAgentStageUpdates/PropertySoldUpload.vue';
import Review from '@/components/LeadAgentStageUpdates/Review.vue';
import Pill from '@/components/Pill.vue';
import OtherAgentLeadStageChangeNotification from '@/components/OtherAgentLeadStageChangeNotification.vue';
import Banner from '@/components/Banner.vue';

import { LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';

const moment = require('moment-business-days');

export default {
  name: 'Lead',
  props: {
    ak: String,
    lk: String,
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case 'leadAgentMappingStore/setLeadAgentMapping':
          if (![
            LeadAgentLeadStageType.Contacted_Vendor,
          ].includes(this.lam.stagetypeid)) {
            this.refreshOpenedSections();
          } else {
            this.fetchContactedDetails();
          }
          break;
        case 'leadAgentMappingStore/setLeadInfo':
          this.refreshOpenedSections();
          break;
        case 'leadAgentMappingStore/pushFile':
          this.refreshOpenedSections();
          break;
        default:
          break;
      }
    });
  },
  components: {
    Pill,
    TimelineAccordian,
    TimelineAccordianItem,
    LeadHeader,
    LeadUnavailableInfo,
    GeneralUpdate,
    PropertyDetails,
    ContactVendor,
    ContactVendorAppraisalDetail,
    PropertyAppraisal,
    PropertyListingManual,
    PropertyListingUpload,
    UnderOffer,
    PropertySoldManual,
    PropertySoldUpload,
    Review,
    OtherAgentLeadStageChangeNotification,
    Banner
  },
  data() {
    return {
      isActive: false,
      displayDefault: true,
      sections: {
        LeadInfo: {
          name: 'LeadInfo',
          isOpen: false,
          userInput: null,
          sendLeadEvent: false,
        },
        Contacted: {
          name: 'Contacted',
          isOpen: false,
          sendLeadEvent: true,
        },
        Appraised: {
          name: 'Appraised',
          isOpen: false,
          sendLeadEvent: true,
        },
        Listed: {
          name: 'Listed',
          isOpen: false,
          sendLeadEvent: true,
        },
        UnderOffer: {
          name: 'UnderOffer',
          isOpen: false,
          sendLeadEvent: true,
        },
        Sold: {
          name: 'Sold',
          isOpen: false,
          sendLeadEvent: true,
        },
        Review: {
          name: 'Review',
          isOpen: false,
          sendLeadEvent: true,
        },
      },
      soldActiveTab: true,
      listedActiveTab: true,
      showGeneralUpdateMsgInput: false,
      contactedDetails: null,
      // listingAgreementUploaded: false,

      // Need to read from store
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
      agentExperiments: state => state.experimentStore.agentExperiments,
    }),
    ...mapGetters('leadAgentMappingStore', [
      'lamIsClosed',
      'lamIsLost',
      'lamIsPassedBack',
      'lamIsClosedCloseLead',
      'lamIsPreListed',
      'lamIsActive',
      'lamIsListed',
      'lamIsOnHold',
      'lamIsOnHoldIgnoredLead',
      'lamStageIsLessThanAttempted',
      'lamStageIsLessThanListed',
      'lamStageIsLessThanContacted',
      'lamStageIsReferred',
      'lamStageIsViewed',
      'lamStageIsEqualOrMoreThanViewed',
      'lamStageIsAttempted',
      'lamStageIsContacted',
      'lamStageIsEqualOrMoreThanContacted',
      'lamStageIsAppraised',
      'lamStageIsEqualOrMoreThanAppraised',
      'lamStageIsAppointed',
      'lamStageIsListed',
      'leadIsListed',
      'leadStageIsEqualOrMoreThanListed',
      'leadIsUnderOffer',
      'leadStageIsEqualOrMoreThanUnderOffer',
      'leadIsSold',
      'leadStageIsEqualOrMoreThanSold',
      'leadIsReviewed',
      'leadStageIsEqualOrMoreThanReviewed',
      'hasListingAgreement',
      'hasContractOfSale',
      'calculatedVLP'
    ]),
    ...mapGetters('bannerStore', [
      'bannerOpen',
    ]),
     ...mapGetters('userStore', [
      'isPremier',
    ]),
    gaLabel() {
      return `AID=${this.lam.agentid} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
      // return `AID=${this.agent.id} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    },
    leadEventSection() {
      if (this.lamStageIsLessThanAttempted) {
        return 'Pre-Accept';
      }
      if (this.lamStageIsLessThanListed) {
        return 'Post-Accepted';
      }
      if (this.lamStageIsListed) {
        return 'Post-Listed';
      }
      return null;
    },
    pillText() {
      if (this.lamIsActive) {
        if (this.lamIsListed) {
          return this.listedPillTxt;
        }
        return this.$helpers.ago((this.lam.agentlastupdatedate || this.lam.modifieddate));
      }
      if (this.lamIsOnHold) {
        return `On hold until ${this.formatDate(this.lam.lamoffholddatetime)}`;
      }
      return this.closedPillTxt;
    },
    leadIsActive() {
      return !this.lamIsLost && !this.lamIsClosed;
    },
    openLeadInfo() {
      // For this section we want to make sure not to overwrite the user input
      // If the user has manually opened or closed the section, then even a lead
      // update cannot change its open/close state
      return this.sections.LeadInfo.userInput
        ? this.sections.LeadInfo.userInput === 'open'
        : (this.displayDefault
          && this.lamStageIsLessThanContacted)
          || this.sections.LeadInfo.isOpen;
    },
    openContacted() {
      return this.displayDefault
        ? this.defaultContactedState
        : this.sections.Contacted.isOpen;
    },
    openAppraised() {
      return (this.displayDefault
        && this.defaultAppraisedState)
        || this.sections.Appraised.isOpen;
    },
    openListed() {
      return (this.displayDefault
        && this.defaultListedState)
        || this.sections.Listed.isOpen;
    },
    openUnderOffer() {
      return (this.displayDefault
        && this.defaultUnderOfferState)
        || this.sections.UnderOffer.isOpen;
    },
    openSold() {
      return (this.displayDefault
        && this.defaultSoldState)
        || this.sections.Sold.isOpen;
    },
    openReview() {
      return (this.displayDefault
        && this.defaultReviewState)
        || this.sections.Review.isOpen;
    },
    alreadyViewed() {
      return this.lamStageIsEqualOrMoreThanViewed
      || this.$helpers.isValidDate(this.lam.leadaccepteddate);
    },
    alreadyContacted() {
      return this.lamStageIsEqualOrMoreThanContacted;
    },
    alreadyAppraised() {
      return this.lamStageIsEqualOrMoreThanAppraised;
    },
    alreadyListed() {
      return this.lamStageIsListed;
    },
    alreadyUnderOffer() {
      return this.lamStageIsListed && this.leadStageIsEqualOrMoreThanUnderOffer;
    },
    alreadySold() {
      return this.lamStageIsListed && this.leadStageIsEqualOrMoreThanSold;
    },
    alreadyReviewed() {
      return this.lamStageIsListed && this.leadStageIsEqualOrMoreThanReviewed;
    },
    defaultLeadInfoState() {
      return this.lamStageIsLessThanContacted;
    },
    defaultContactedState() {
      return this.lamStageIsViewed || this.lamStageIsAttempted
      || (this.lamStageIsContacted && this.isMissingContactedAppraisalDetails);
    },
    defaultAppraisedState() {
      return this.lamStageIsContacted && !this.isMissingContactedAppraisalDetails;
    },
    defaultListedState() {
      return this.lamStageIsAppraised || this.lamStageIsAppointed;
    },
    defaultUnderOfferState() {
      return this.lamIsListed && this.leadIsListed;
    },
    defaultSoldState() {
      return this.lamStageIsListed && this.leadIsUnderOffer;
    },
    defaultReviewState() {
      return this.lamStageIsListed && this.leadIsSold;
    },
    isMissingContactedAppraisalDetails() {
      return this.contactedDetails === null
        || `${this.contactedDetails.arrangedappraisalid}` !== '1';
    },
    requiredUpdate() {
      if (!this.lam.agentlastupdatedate) return true;
      const date = moment(new Date(`${this.lam.agentlastupdatedate} UTC`));
      if (this.lamIsActive && !this.lamIsListed) {
        /**
         * Referred and Viewed
         * always action required (red)
         */
        if (this.lamStageIsReferred || this.lamStageIsViewed) return true;
        /**
         * Attempted
         * if updated more than 1 business day ago --> action required (red)
         * if updated less than 1 business day ago --> action not required (gray)
         */
        if (this.lamStageIsAttempted) {
          return (moment().utc().businessDiff(date, 'days') >= 1);
        }

        /**
         * Contacted
         * if updated more than 7 business day ago --> action required (red)
         * if updated less than 7 business day ago --> action not required (gray)
         */
        if (this.lamStageIsContacted) {
          return (moment().utc().businessDiff(date, 'days') >= 7);
        }

        /**
         * Appraised
         * if updated more than 7 business day ago --> action required (red)
         * if update less than 7 business day ago --> action not required (gray)
         */
        if (this.lamStageIsAppraised) {
          return (moment().utc().businessDiff(date, 'days') >= 7);
        }

        /**
         * Appointed
         * if updated more than 7 business day ago --> action required (red)
         * if updated less than 7 business day ago --> action not required (gray)
         */
        if (this.lamStageIsAppointed) {
          return (moment().utc().businessDiff(date, 'days') >= 7);
        }
      }

      /**
       * On hold --> action not required (grey)
       */

      /**
       * Listed --> action not required happy color (green)
       */

      /**
       * Closed --> action not required (gray)
       */

      return false;
    },
    listedPillTxt() {
      return (this.leadIsSold || this.leadIsReviewed)
        ? `Sold ${this.$options.filters.formatDate(this.lead.solddate)}`
        : `Listed ${this.$options.filters.formatDate(this.lead.listingdate)}`;
    },
    closedPillTxt() {
      return (this.lamIsClosed)
        ? `Closed on ${this.$options.filters.formatDate(this.lam.leaddeclineddate)}`
        : `Lost on ${this.$options.filters.formatDate(this.lam.leadlostdate)}`;
    },
    virtualToursLpUrl() {
        return `${process.env.VUE_APP_OA_VIRTUAL_TOURS_LP}?lk=${ this.lead.key }&ak=${ this.agent.key }`;
    },
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadAgentMapping',
      'sendLeadEvent',
    ]),
    ...mapActions('bannerStore', [
      'changeState',
    ]),
    fetchData() {
      if (this.lk !== null && this.lk !== this.lam.key && this.ak !== null) {
        const payload = { leadKey: this.lk, agentKey: this.ak };
        this.$store
          .dispatch('leadAgentMappingStore/loadLeadAgentMapping', payload)
          .then(() => {
            // On load we want to set the LAM to Viewed if needs be
            this.setLamToViewed();

            this.fetchAgentFiles();

            // Set the sections to Open/Close by default depending on lam stage/state
            this.setOpenedSections();
          // })
          // .catch((err) => {
            // this.$router.push({
            //   name: '404',
            //   params: {
            //     msg: err,
            //   },
            // });
          });
      }
    },
    formatDate(dateString) {
      return this.$helpers.formatDate(dateString);
    },
    refreshOpenedSections() {
      this.displayDefault = true;
      this.setOpenedSections();
      window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrolls to the top of the page
    },
    disableDefaultDisplay() {
      this.displayDefault = false;
    },
    setOpenedSections() {
      this.sections.LeadInfo.isOpen = this.defaultLeadInfoState;
      this.sections.Contacted.isOpen = this.defaultContactedState;
      this.sections.Appraised.isOpen = this.defaultAppraisedState;
      this.sections.Listed.isOpen = this.defaultListedState;
      this.sections.UnderOffer.isOpen = this.defaultUnderOfferState;
      this.sections.Sold.isOpen = this.defaultSoldState;
      this.sections.Review.isOpen = this.defaultReviewState;
    },
    setLamToViewed() {
      if (this.lamStageIsReferred
      && (this.lamIsActive || (this.lamIsOnHold && this.lamIsOnHoldIgnoredLead))) {
        this.moveToViewed();
      }
    },
    moveToViewed() {
      const data = {
        stagetypeid: LeadAgentLeadStageType.Viewed,
      };
      return this.updateLeadAgentStage(data);
    },
    updateLeadAgentStage(data) {
      if (!data.oauserid && !!this.user) {
        data.oauserid = this.user.id;
        data.oauserkey = this.user.key;
      }
      const payload = {
        lamid: this.lam.id,
        data,
      };
      return this.updateLeadAgentMapping(payload);
    },
    headerClicked(values) {
      this.displayDefault = false;
      if (values.name) {
        if (values.state === false) {
          this.sections[values.name].isOpen = true;
          this.sections[values.name].userInput = 'open';
          // if (values.name === this.sections.LeadInfo.name) {
          //   this.$helpers.gaEvent('Agent Referral', 'Expand vendor and property details', this.gaLabel);
          // }
        } else {
          this.sections[values.name].isOpen = false;
          this.sections[values.name].userInput = 'close';
        }
        if (this.sections[values.name].sendLeadEvent) {
          this.leadEvent(values);
        }
      }
    },
    leadActionMsgClicked(value) {
      this.showGeneralUpdateMsgInput = value;
    },
    leadEvent(values) {
      const data = {
        action: `Leads Management - Click checkbox item - ${values.name}`,
        newvalue: (values.state ? 'Open' : 'Close'),
      };
      this.logLeadEvent(data);
    },
    logLeadEvent(data) {
      const leadEventData = {
        leadid: this.lead.id,
        agentid: this.lam.agentid,
        // agentid: this.agent.id,
        userkey: !!this.user && !!this.user.key ? this.user.key : this.agent.userkey,
        // userkey: this.agent.userkey,
        leadeventsource: 'Agent Portal',
        leadeventsourcesection: `Single Deal Page - ${this.leadEventSection}`,
        leadeventaction: data.action,
        oldvalue: '',
        newvalue: data.newvalue,
      };
      return this.$apiServices.oa.lead.sendLeadEvent(leadEventData);
    },
    fetchAgentFiles(type) {
      return new Promise((resolve, reject) => {
        if (this.lam.agentid && this.lam.leadid) {
          const payload = {
            leadId: this.lam.leadid,
            agentId: this.lam.agentid,
            type,
          };
          this.$store.dispatch('leadAgentMappingStore/getAgentUploadedFiles', payload)
            .then((files) => {
              resolve(files);
            }, (err) => {
              reject(err);
            });
        } else {
          reject(new Error('Missing agentid or leadid'));
        }
      });
    },
    setContactedDetails(details) {
      this.contactedDetails = details;

      // Once the contact update is made, we want to close that section, and not open anything else
      // (no call to refreshOpenedSections)
      this.sections.Contacted.isOpen = false;
      this.displayDefault = false;
    },
    fetchContactedDetails() {
      this.$apiServices.oa.leadAgent.getContactedDetails(this.lam.id)
        .then(details => this.contactedDetails = details || {})
        .catch(() => this.contactedDetails = {});
    },
    closeBanner() {
      this.changeState(false);
    }
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .tabs {
    @apply ut-border ut-border-green-400;
    border-radius: 4px;
    display: inline-block;
    @apply ut-mb-8;
  }
  .tab {
    @apply ut-text-green-400;
    padding: 12px 20px;
    font-weight: bold;
    font-size: 14px;
  }
  .tab-active {
    @apply ut-bg-green-400;
    color: #fff;
  }
  @screen md {
    .tab {
      padding: 12px 40px;
    }
  }
</style>
